import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

@Component({
    selector: 'cs-fav-cta',
    styleUrl: './fav-cta.component.scss',
    templateUrl: './fav-cta.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavCtaComponent {
    favVariants = FavVariantType;
    favIconKinds = FavIconKindType;
    showIcon = input<boolean, string>(false, {
        transform: booleanAttribute,
    });
    variant = input.required<FavVariant>();
    iconKind = input.required<FavIconKind>();
}

export enum FavVariantType {
    Filled = 'filled',
    Hollow = 'hollow',
}

export enum FavIconKindType {
    Star = 'star',
    Heart = 'heart',
}
export type FavVariant = FavVariantType;
export type FavIconKind = FavIconKindType;
